import colors from '../colors';

const button = {
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: '16px',
        fontWeight: 600,
        height: '52px',

        '&.MuiButton-root': {
          borderRadius: '5px',
          textTransform: 'none',
        },

        '&.MuiButton-outlined': {
          border: `2px solid ${colors.palette.primary.main}`,

          '&:hover': {
            background: colors.palette.neutral.main,
          },
        },

        '&:disabled': {
          background: colors.palette.primary.main,
          color: colors.palette.white,
          opacity: 0.5,
        },
      },
    },
  },
};

export default button;
